export default __webpack_public_path__ + "static/media/resid-credicard.8a1c7f80.jpg";